import * as Constants from '../constants';

const initialState = {
  isLoading: false,
  error: null,
  mid: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_ACTIVATION_STATUS:
      return { ...state, isLoading: true, error: null };
    case Constants.RECEIVE_ACTIVATION_STATUS:
      if (action.error) {
        console.log(`Receive Activation Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          error: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        mid: action.activationStatus.activation.mid,
        error: null
      };
    case Constants.REQUEST_ACTIVATION:
      return { ...state, isLoading: true, error: null };
    case Constants.RECEIVE_ACTIVATION:
      if (action.error) {
        console.log(`Receive Activation Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          error: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        mid: action.activationStatus.activation.mid,
        error: null
      };
    default:
      return state;
  }
}
